module.exports = __webpack_public_path__ + "static/media/irregular-income.08f67743.svg";